import React from 'react';
import { enumHelper } from '../../utils';
import ENUMS from '../../enums/index';
import { NavLink } from 'react-router-dom';
import { useHistory, generatePath } from 'react-router-dom';


export const citiesListColumns = [
  {
    title: 'ردیف',
    isRowNumber: true,
  },
  {
    title: 'نام شهر',
    dataIndex: 'name',
    name: 'name',
    isSortable: true,
  },
  {
    title: 'کد شهر',
    dataIndex: 'cityCode',
    name: 'cityCode',
    isSortable: true,
  },
  {
    title: 'ویرایش',
    dataIndex: '',
    name: '',
    isSortable: false,
    permission: ENUMS.PERMISSIONS.values.EDIT_CITY,
    action: item => (
      <NavLink
        to={{
          pathname: '/add-or-edit-city',
          editMode: true,
          item: item,
        }}
        title={locales('edit.city')}
      >
        <i className='text-success text-center fal fa-pen-square pointer' />
      </NavLink>
    ),
  },
  {
    title: 'مشاهده مناطق',
    dataIndex: '',
    name: '',
    isSortable: false,
    permission: ENUMS.PERMISSIONS.values.VIEW_REGIONS_LIST,
    action: item => (
      <NavLink
        to={{
          pathname: `/regions-of-city`,
          redirect: true,
          item: item,
        }}
        title={locales('see.regions.list')}
      >
        <i className="text-center fal fa-receipt pointer" />
      </NavLink>
    ),
  },
];